export const columnSchema = {
  $id: '/NumberAxis',
  type: 'object',
  additionalProperties: false,
  properties: {
    headerName: { type: ['string', 'null'], default: null },
    accessor: { type: ['string'], default: null }
  },
  required: ['accessor']
};

export const GRID_SCHEMAS = [columnSchema];